import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import {
  useUpdateData,
  useUpdateDataWithImage,
} from "../../../hooks/useUpdateData";
import {
  useInsertData,
  useInsertDataWithImage,
} from "../../../hooks/useInsertData";
import notify from "../../../components/notify";
import { useDeleteData } from "../../../hooks/useDeleteData";
import i18n from "../../../i18n/i18n";

// ✅ PRODUCTS

export const getAllProducts = createAsyncThunk(
  "/productSlice/getAllProducts",
  async ({ query = "" }) => {
    try {
      const response = await useGetData(`/products?${query}`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);

export const getOneProduct = createAsyncThunk(
  "/productSlice/getOneProduct",
  async (id) => {
    try {
      const response = await useGetData(`/products/${id}`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);


export const orderRequest = createAsyncThunk(
  "/productSlice/orderRequest",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`/orders`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data?.message, "error");
        return rejectWithValue(error.response?.data?.message);
      }
    }
  },
);

export const getAllOrders = createAsyncThunk(
  "/productSlice/getAllOrders",
  async ({id,query}) => {
    try {
      const response = await useGetData(`/orders/user/${id}?${query}`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);
